import { ProjectImportStatsTable } from '../views/project-import-stats-table';
import { ProjectImportStats } from '../dtos/project-import-stats';

export const PROJECT_IMPORT_STATS_TABLE = (
	projectImportStatsList: Array<ProjectImportStats> = [],
	usersList: Array<any> = []
): Array<ProjectImportStatsTable> => {
	let results: Array<ProjectImportStatsTable> = [];
	try {
		if (projectImportStatsList.length > 0) {
			projectImportStatsList.map((projectImportStat: ProjectImportStats) => {
				let row = {} as ProjectImportStatsTable;
				row.userId = projectImportStat.userId;
				if (row.userId) {
					const user = usersList?.find((user) => user.userId == row.userId);
					if (user) {
						row.userName = user?.name;
					}
				}
				row.created = projectImportStat.created;
				row.fileName = projectImportStat.fileName;
				row.id = projectImportStat.id;
				row.jobStatus = projectImportStat.jobStatus;
				row.rowsFailed = projectImportStat.rowsFailed;
				row.rowsInserted = projectImportStat.rowsInserted;
				row.rowsParsed = projectImportStat.rowsParsed;
				row.totalRows = projectImportStat.totalRows;
				row.lastModified = projectImportStat.lastModified;
				results.push(row);
			});
		}
	} catch (error) {
		console.log('PROJECT_IMPORT_STATS_TABLE error: ', error);
	}

	return results;
};
